import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import ErrorBoundary from '@/components/ErrorBoundary';
import './i18n';
import { theme } from './theme/theme';
import './styles/main.scss';
import { OrgSyncProvider } from './context/OrgSyncProvider';
import { loadAIAssistant } from './services/aiAssistantLoader';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <OrgSyncProvider>
              <CssBaseline />
              <App />
            </OrgSyncProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Загружаем AI Assistant Widget после инициализации приложения
// Виджет сам читает localStorage и подписывается на события
// loadAIAssistant(); // временно отключено